import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, Users, Scissors, Truck, Package, LogOut, Settings } from 'lucide-react';

const links = [
  { to: '/admin', label: 'Dashboard', icon: <LayoutDashboard size={16} />, exact: true },
  { section: 'Data Master' },
  { to: '/admin/hewan', label: 'Hewan Qurban', icon: '🐄' },
  { to: '/admin/pengkurban', label: 'Pengkurban', icon: <Users size={16} /> },
  { section: 'Proses' },
  { to: '/admin/proses', label: 'Penyembelihan & Packing', icon: <Scissors size={16} /> },
  { to: '/admin/distribusi', label: 'Distribusi', icon: <Package size={16} /> },
  { section: 'Kurir' },
  { to: '/admin/kurir', label: 'Manajemen Kurir', icon: <Truck size={16} /> },
  { section: 'Akun' },
  { to: '/admin/settings', label: 'Pengaturan & Password', icon: <Settings size={16} /> },
];

export default function AdminSidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="sidebar">
      <div style={{ padding: '0 16px 16px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
        <div style={{ fontSize: 11, color: '#5a9a6e', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>Panel</div>
        <div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Admin Qurban</div>
      </div>
      {links.map((item, i) => {
        if (item.section) return <div key={i} className="sidebar-section">{item.section}</div>;
        return (
          <NavLink key={i} to={item.to} end={item.exact} className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}>
            <span style={{ fontSize: 16 }}>{item.icon}</span> {item.label}
          </NavLink>
        );
      })}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '1rem 0', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
        <button onClick={handleLogout} className="sidebar-link" style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer' }}>
          <LogOut size={16} /> Keluar
        </button>
      </div>
    </div>
  );
}
